var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"list-unstyled"},_vm._l((_vm.field.nodes),function(item,index){return _c('TreeViewItem',{key:`treeview-${index}`,staticClass:"item",attrs:{"item":item}},[_vm._v(" "+_vm._s(item.displayName)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }